import {
  sanity_image_default
} from "./chunk-S7ZUUURB.js";
import {
  button_default
} from "./chunk-4RZJ54WQ.js";
import {
  icon_default
} from "./chunk-KWWZIFUJ.js";

// src/blocks/video/video.tsx
import { useCallback, useEffect, useRef, useState } from "react";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var Video = ({
  className,
  fit,
  id,
  image,
  highResSrc,
  lowResSrc,
  width,
  height,
  gradient,
  buttonClassName = "",
  onVideoStart
}) => {
  if (!image) {
    return;
  }
  const videoRef = useRef(null);
  const [hasPlayed, setHasPlayed] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [showVideo, setShowVideo] = useState(false);
  const onPlay = () => {
    setHasPlayed(true);
    setIsPlaying(true);
  };
  const onPause = () => {
    setIsPlaying(false);
  };
  const onPlayPauseClick = useCallback(() => {
    if (isPlaying) {
      videoRef.current?.pause();
    } else {
      videoRef.current?.play();
    }
  }, [isPlaying]);
  useEffect(() => {
    hasPlayed && onVideoStart && onVideoStart();
  }, [hasPlayed, onVideoStart]);
  useEffect(() => {
    setShowVideo(true);
  }, []);
  return /* @__PURE__ */ jsxs("div", { className, id, children: [
    showVideo && /* @__PURE__ */ jsxs(
      "video",
      {
        ref: videoRef,
        loop: true,
        muted: true,
        autoPlay: !window.matchMedia("(prefers-reduced-motion)").matches,
        playsInline: true,
        onPlay,
        onPause,
        className: `${fit} w-full h-full`,
        children: [
          /* @__PURE__ */ jsx("source", { src: highResSrc, media: "(min-width: 1024px)" }),
          /* @__PURE__ */ jsx("source", { src: lowResSrc })
        ]
      }
    ),
    /* @__PURE__ */ jsx(
      sanity_image_default,
      {
        sanityImageSourceData: image,
        width,
        height,
        className: `absolute left-0 top-0 w-full h-full ${hasPlayed ? "opacity-0" : "opacity-100"} transition-opacity-in`,
        imageClassName: `${fit} w-full h-full`
      }
    ),
    gradient && /* @__PURE__ */ jsx(Fragment, { children: gradient }),
    onPlayPauseClick && /* @__PURE__ */ jsx(
      button_default,
      {
        a11yLabel: "video play/pause button",
        className: `button-icon-pause absolute bottom-6 right-[1.5rem] min-[1440px]:right-[calc(0.5*(calc(100*var(--vw))-1440px)+1.5rem)] z-1 ${buttonClassName}`,
        icon: /* @__PURE__ */ jsx(
          icon_default,
          {
            name: isPlaying ? "pause" : "play",
            className: `block ${isPlaying ? "w-[0.6875rem] h-[0.6875rem]" : "w-[1rem] h-[1rem]"}`,
            SVGClassName: "w-full h-auto"
          }
        ),
        onClick: onPlayPauseClick
      }
    )
  ] });
};
var video_default = Video;

export {
  video_default
};
